import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { checkAccess } from 'app/actions/app.actions';
import { INSTANT_GAME_TYPE, DRAW_GAME_TYPE } from 'app/actions/game-images.actions';
import {
  JACKPOT_ID,
  BIG_WINNERS_ONLINE_ID,
  BIG_WINNERS_SCRATCH_ID,
  PRICES_PAID_WTD_ID,
  PRICES_PAID_MTD_ID,
  PRICES_PAID_YTD_ID,
} from 'dashboard/dashboard-helpers';
import template from './media-templates.html';

const mapStateToThis = ({ session, dictionary }) => {
  const { locale } = session;
  const terms = dictionary.terms[locale];

  return {
    terms,
  };
};

const mapDispatchToThis = {
  setDirtyForm,
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'DirtyForm')
class CmsMediaTemplatesController {
  constructor() {
    this.INSTANT_GAME_TYPE = INSTANT_GAME_TYPE;
    this.DRAW_GAME_TYPE = DRAW_GAME_TYPE;
    this.JACKPOT_ID = JACKPOT_ID;
    this.BIG_WINNERS_ONLINE_ID = BIG_WINNERS_ONLINE_ID;
    this.BIG_WINNERS_SCRATCH_ID = BIG_WINNERS_SCRATCH_ID;
    this.PRICES_PAID_WTD_ID = PRICES_PAID_WTD_ID;
    this.PRICES_PAID_MTD_ID = PRICES_PAID_MTD_ID;
    this.PRICES_PAID_YTD_ID = PRICES_PAID_YTD_ID;
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.hasDashboardSharePrivilege = this.checkAccess('dashboard.dashboardShare');
    this.hasJackpotsNextDrawsPrivilege = this.checkAccess('dashboard.widget.jackpotsNextDraws');
    this.hasBigWinnersPrivilege = this.checkAccess('dashboard.widget.bigWinners');
    this.hasCumulativeWinnersPrivilege = this.checkAccess('dashboard.widget.cumulativeWinners');
    this.hasAccessToMediaTemplatesPage = this.hasDashboardSharePrivilege && (this.hasJackpotsNextDrawsPrivilege || this.hasBigWinnersPrivilege || this.hasCumulativeWinnersPrivilege);

    if (!this.hasAccessToMediaTemplatesPage) {
      this.$state.go('permissions-denied');
    }

    switch (true) {
      case this.hasJackpotsNextDrawsPrivilege:
        this.activeTabIdx = this.JACKPOT_ID;
        break;
      case this.hasBigWinnersPrivilege:
        this.activeTabIdx = this.BIG_WINNERS_SCRATCH_ID;
        break;
      case this.hasCumulativeWinnersPrivilege:
        this.activeTabIdx = this.PRICES_PAID_WTD_ID;
        break;
      default:
        // eslint-disable-next-line no-console
        console.error('MEDIA TEMPLATES: The user cannot access any of the available templates.');
    }
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onTabSelect(tabId) {
    this.DirtyForm.check(this.activeTabIdx, (dirty) => {
      if (dirty) {
        this.setDirtyForm(this.activeTabIdx, false);
      }
      this.activeTabIdx = tabId;
    });
  }
}

export default class CmsMediaTemplatesComponent {
  constructor() {
    this.controller = CmsMediaTemplatesController;
    this.template = template;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/media-templates/media-templates-component.js